import { render } from "./CompanyReportRPKDetails.vue?vue&type=template&id=55b83850&ts=true"
import script from "./CompanyReportRPKDetails.vue?vue&type=script&lang=ts"
export * from "./CompanyReportRPKDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__